export class AuthenticationRequest
{
  userName: string;
  password: string;
  origin: string;
}